import { Injectable } from '@angular/core';
import { ParametersService } from './parameters.service';
import { RoiService } from './roi.service';
import { VehicleDamagePipe } from '../pipes/vehicle-damage.pipe';
import { Style } from '../model/settings.model';
import { DamageAnalysis } from '../model/damage.model';
import { environment } from '../../environments/environment';
import { fabric } from 'fabric_gesture';
import { setTimeout } from 'timers';
import { HydratedTchek, Tchekb } from '../model/tchekb.model';
import { Subject } from 'rxjs';
import { DamageService } from './damage.service';


@Injectable()
export class ThumbnailService {

  style: Style;
  numberOfDamage: number;


  constructor(private readonly _parametersService: ParametersService,
    readonly _roiService: RoiService,
    private readonly _vehicledamage: VehicleDamagePipe,
    private readonly _damageService: DamageService
  ) {
    this.style = this._parametersService.getAll().style;
    if (!this.style)
      this.style = { damageColor: 'white', newDamageColor: 'red', dashboard: [], contrast: 0, gamma: 1, saturation: 0 };
  }


  getSize(damage: DamageAnalysis): { w: number, h: number } {
    let size = { w: 3088, h: 2076 }
    let tchek = damage.tchekPtr
    let cameraNumber = damage.roiPtr.folder
    if ((tchek.type === undefined || tchek.type < 3) && tchek && tchek.camConfig && tchek.camConfig[cameraNumber]) {
      size.w = tchek.camConfig[cameraNumber].width
      size.h = tchek.camConfig[cameraNumber].height
    } else if (damage.roiPtr && damage.roiPtr.imagePtr && damage.roiPtr.imagePtr.size) {
      size.w = damage.roiPtr.imagePtr.size.width
      size.h = damage.roiPtr.imagePtr.size.height
    }
    return size
  }

  generateOverlay(damage: DamageAnalysis): Promise<string> {
    return new Promise((resolve, reject) => {
      let size = this.getSize(damage)
      // Draw the image and its ROIs and rasterize
      const canvas = new fabric.Canvas(document.createElement('canvas'));
      canvas.setWidth(size.w);
      canvas.setHeight(size.h);
      if (damage.roiPtr.imagePtr === undefined || damage.tchekPtr.type >= 2)
        this.addRoisToCanvas(canvas, damage, false).then(_ => {
          resolve(canvas.toDataURL({ format: 'png' }));
        });
      else resolve(canvas.toDataURL({ format: 'png' }));
    });
  }

  getDataUri(damage: DamageAnalysis, download: boolean, linkImage: string): Promise<any> {
    /* image.crossOrigin = "anonymous";
    image.setAttribute("crossOrigin", "anonymous"); */
    return new Promise((resolve, reject) => {
      let size = this.getSize(damage)
      const maxWidth = size.w, maxHeight = size.h;
      fabric.textureSize = size.w * size.h; // Setting max texture size to HiRes pictures resolution
      fabric.Image.fromURL(linkImage, (myImg) => {
        myImg.crossOrigin = 'anonymous';
        // Draw the image and its ROIs and rasterize
        const canvas = new fabric.Canvas(document.createElement('canvas'));
        canvas.setWidth(maxWidth);
        canvas.setHeight(maxHeight);
        myImg.scaleToWidth(canvas.getWidth());
        canvas.add(myImg);

        if (damage.roiPtr.imagePtr === undefined || damage.tchekPtr.type >= 2)
          this.addRoisToCanvas(canvas, damage, download).then(_ => {
            console.log("return get data", canvas);
            resolve(canvas);
          });
        else resolve(canvas);
      }, { crossOrigin: 'anonymous' });
    });
  }


  downloadImage(damage: DamageAnalysis): Promise<any> {
    return new Promise((resolve, reject) => {
      let linkImage;
      if (damage.roiPtr.imagePtr === undefined || damage.tchekPtr.type >= 2)
        if (damage.uploadPicture
          || ((damage.tchekPtr.uploadHDPictures || (environment.isLocal && damage.tchekPtr.isHDLocal !== false)) && damage.bestImageUrl.hd))
          linkImage = damage.bestImageUrl.hd;
        else
          linkImage = damage.bestImageUrl.mini;
      else
        linkImage = damage.roiPtr.imagePtr.file.url()

      this.getDataUri(damage, true, linkImage).then(canva => {

        let a = document.createElement("a");
        if (damage.uploadPicture
          || ((damage.tchekPtr.uploadHDPictures || (environment.isLocal && damage.tchekPtr.isHDLocal !== false)) && damage.bestImageUrl.hd))
          a.href = canva.toDataURL({ format: 'jpeg', quality: 0.90 });
        else
          a.href = canva.toDataURL({ format: 'jpeg' });

        a['download'] = `immat-${damage.tchekPtr.vehiclePtr.immat}-dommage-${damage.uid}`;
        let e = document.createEvent("MouseEvents");
        // Use of deprecated function to satisfy TypeScript.
        setTimeout(() => {
          resolve(true);
          e.initMouseEvent("click", true, false,
            document.defaultView, 0, 0, 0, 0, 0,
            false, false, false, false, 0, null);
          a.dispatchEvent(e);
        }, 2000);
      })
    })
  }

  // Add ROIs to canvas
  addRoisToCanvas = function (canvasRef, damage: DamageAnalysis, download: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      // Adding ROIs to canvas if any
      if (damage.roiPtr) {
        let roiCircle;
        roiCircle = new fabric.Circle({
          id: 0,
          left: 0,
          top: 0,
          fill: 'transparent',
          radius:
            damage.roiPtr.radius * canvasRef.getWidth(),
          strokeWidth: download === true ? 5 : 10,
          stroke: this.style.damageColor,
          selectable: false,
          originX: 'center',
          originY: 'center',
          draggable: false,
          lockRotation: true,
          hasControls: false
        });
        let roiText = new fabric.Text(
          this._vehicledamage.transform(damage.type), {
          fontSize: 28,
          fontFamily: 'Open Sans',
          fill: 'white',
          fontWeight: 'bold',
          originX: 'center',
          originY: 'bottom',
          draggable: false,
          selectable: false,
          lockRotation: true,
          hasControls: false,
          left: 0,
          top: - damage.roiPtr.radius * canvasRef.getWidth() -
            16,
          //shadow: 'rgba(0,0,0,0.6) 2px 2px 1px'
        });
        const roiTextBox = new fabric.Rect({
          width: roiText.getScaledWidth() + 32 + 16,
          height: roiText.getScaledHeight() + 8,
          cornerStyle: 'circle',
          strokeLineJoin: 'round',
          strokeWidth: 10,
          stroke: 'rgb(105,183,182)',
          fill: 'rgb(105,183,182)',
          originX: 'center',
          originY: 'bottom',
          left: roiText.getCenterPoint().x,
          top: roiText.top + 8
        });
        const roiTextNotch = new fabric.Triangle({
          width: 12,
          height: 6,
          originX: 'center',
          originY: 'bottom',
          fill: 'rgb(105,183,182)',
          left: roiTextBox.left,
          top: roiTextBox.top - 1,
          angle: 180
        });
        if (download)
          canvasRef.add(new fabric.Group([roiCircle, roiTextNotch, roiTextBox, roiText], {
            left:
              (damage.roiPtr.centerX * canvasRef.getWidth()),
            top:
              (damage.roiPtr.centerY * canvasRef.getHeight() + roiTextBox.top / 2),
            originX: 'center',
            originY: 'center',
            lockRotation: true,
            hasControls: false,
            selectable: this.editMode,
            evented: this.editMode,
            parseId: damage.roiPtr.id,
            isAuto: damage.roiPtr.isAuto,
            isValidated: damage.roiPtr.isValidated,
            opacity: 1
          }));
        else
          canvasRef.add(new fabric.Group([roiCircle], {
            left:
              (damage.roiPtr.centerX * canvasRef.getWidth()),
            top:
              (damage.roiPtr.centerY * canvasRef.getHeight()), //+ roiTextBox.top / 2),
            originX: 'center',
            originY: 'center',
            lockRotation: true,
            hasControls: false,
            selectable: this.editMode,
            evented: this.editMode,
            parseId: damage.roiPtr.id,
            isAuto: damage.roiPtr.isAuto,
            isValidated: damage.roiPtr.isValidated,
            opacity: 1
          }));
        resolve(canvasRef);
      } else {
        resolve(canvasRef);
      }
    });
  };


}



// WEBPACK FOOTER //
// ./src/app/service/thumbnail.service.ts